import configurationService from '../services/configurationService';

export const attachmentDownloadUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';
  return `${prefix}/api/v2/prospectAttachment/getAttachment?prospectID=${prospectId}&attachmentID=${attachmentId}`;
};

export const attachmentUrlV2 = ({
  jobId,
  applicationCorrelationId,
  attachmentType,
  actionType,
  blobId,
}: {
  jobId: string;
  applicationCorrelationId: string;
  attachmentType: 'Resume' | 'CoverLetter' | 'Other' | 'SelectionCriteria'; // TODO: sync up with graph type
  actionType: 'download' | 'preview'; // todo: sync up with graph type
  blobId: string;
}) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';

  const searchParams = new URLSearchParams();
  searchParams.append('jobId', jobId);
  searchParams.append('applicationCorrelationId', applicationCorrelationId);
  searchParams.append('attachmentType', attachmentType);
  searchParams.append('actionType', actionType);
  searchParams.append('blobId', blobId);

  return `${prefix}/attachment/applications?${searchParams.toString()}`;
};

export const attachmentPreviewUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';

  return `${prefix}/api/v2/prospectAttachment/getAttachmentFile?prospectId=${prospectId}&attachmentId=${attachmentId}&preview=true`;
};
